import { Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnDestroy, Output } from '@angular/core';

@Component({
  selector: 'app-program-share',
  templateUrl: './program-share.component.html',
  styleUrls: ['./program-share.component.scss']
})
export class ProgramShareComponent implements OnDestroy {
  @Input() title = '';
  @Input() url = '';
  @Output() openChange = new EventEmitter<boolean>();

  isOpen = false;
  copied = false;
  private copyResetTimer?: ReturnType<typeof setTimeout>;

  constructor(private elementRef: ElementRef<HTMLElement>, private zone: NgZone) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isOpen) return;
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.setOpen(false);
    }
  }

  toggle(event: Event): void {
    event.stopPropagation();
    this.setOpen(!this.isOpen);
  }

  private setOpen(open: boolean): void {
    this.isOpen = open;
    this.openChange.emit(open);
  }

  get links(): Record<'facebook' | 'linkedin' | 'whatsapp' | 'email' | 'instagram', string> {
    const url = encodeURIComponent(this.url);
    const title = encodeURIComponent(this.title);
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
      whatsapp: `https://api.whatsapp.com/send?text=${title}%20${url}`,
      email: `mailto:?subject=${title}&body=${url}`,
      instagram: `https://www.instagram.com/`
    };
  }

  copyLink(event: Event): void {
    event.stopPropagation();
    navigator.clipboard?.writeText(this.url).then(() => {
      this.copied = true;
      clearTimeout(this.copyResetTimer);
      this.copyResetTimer = setTimeout(() => {
        this.zone.run(() => this.copied = false);
      }, 1500);
    });
  }

  ngOnDestroy(): void {
    clearTimeout(this.copyResetTimer);
  }
}
